/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerModel } from '../../models/practitioner-model';

export interface FacilityClinicGroupIdPractitionersFacilityIdPost$Params {
  clinicGroupId: string;
  facilityId: string;
}

export function facilityClinicGroupIdPractitionersFacilityIdPost(http: HttpClient, rootUrl: string, params: FacilityClinicGroupIdPractitionersFacilityIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PractitionerModel>>> {
  const rb = new RequestBuilder(rootUrl, facilityClinicGroupIdPractitionersFacilityIdPost.PATH, 'post');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<PractitionerModel>>;
    })
  );
}

facilityClinicGroupIdPractitionersFacilityIdPost.PATH = '/Facility/{clinicGroupId}/Practitioners/{facilityId}';
